
import React, { useEffect } from 'react';
import { WandSparkles } from 'lucide-react';
import { StandardTextAreaField } from '@/components/ui/form-fields';
import styles from '../FilterBar.module.css';
import { motion } from 'framer-motion';
import GlassPill from '@/components/ui/GlassPill';

interface DescriptionFieldProps {
  imageDescription: string;
  onImageDescriptionChange: (value: string) => void;
}

const DescriptionField: React.FC<DescriptionFieldProps> = ({ 
  imageDescription, 
  onImageDescriptionChange 
}) => {
  // Add debounced search to avoid too many API calls when typing
  const handleDescriptionChange = (value: string) => {
    onImageDescriptionChange(value);
  };
  
  // Calculate word count
  const wordCount = imageDescription.trim().split(/\s+/).filter(word => word.length > 0).length;
  const isValidLength = wordCount >= 1;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, delay: 0.1 }}
    >
      <div className="mb-3">
        <h3 className="text-sm font-medium mb-1 text-purple-600 dark:text-purple-400">Image Description</h3>
      </div>
      <div className="relative">
        <StandardTextAreaField
          id="image-description"
          label="" /* Label removed */
          value={imageDescription}
          onChange={handleDescriptionChange}
          placeholder="e.g. A serene mountain landscape at sunset"
          rows={4}
          className={styles.vibrantInput}
        />
        
        {/* Word count indicators */}
        <div className="flex items-center gap-2 mt-2">
          {wordCount < 1 && (
            <GlassPill 
              type="Min 1 word"
              variant="amber"
              className="text-xs py-0.5 px-2"
            />
          )}
          <GlassPill 
            type={`${wordCount} words`}
            variant={isValidLength ? "blue" : "gray"}
            className="text-xs py-0.5 px-2"
          />
        </div>
      </div>
    </motion.div>
  );
};

export default DescriptionField;
